// import { withStyles } from '@mui/styles';
import {
  action,
  makeObservable,
  observable,
  reaction,
  runInAction,
  toJS,
} from "mobx";
import React from "react";

import * as utils from "@intrasync/utils";

// import LinearProgress from '../Progress/LinearProgress';
// import style from './splashScreenStyle';
import { Button, Spacer, injectStores } from "@intrasync/react";
// import RootStore from '@intrasync/stores';
import Logo from "../Logo/Logo";

declare const window: Window;

const DEFAULT_ERROR_MESSAGE = `Something's wrong...`;
const CONNECTION_ERROR_MESSAGE = `Looks like we couldn't connect to the server`;

import { CSSProperties } from "react";
import {
  ConnectionStore,
  RouterStore,
  ServiceStore,
  ViewStore,
} from "@intrasync/stores";

const styles: { [key: string]: CSSProperties } = {
  page: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: 10,
    height: "100vh",
  },
  body: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: 10,
  },
  message: {
    textAlign: "center",
    marginTop: 20,
    marginBottom: 5,
  },
};

interface SplashScreenProps {
  viewStore?: ViewStore;
  message?: string;
  connectionStore?: ConnectionStore;
  logStore?: ServiceStore;
  routerStore?: RouterStore;
}

class SplashScreen extends React.PureComponent<SplashScreenProps> {
  timeOutMessage = "";
  connectionRestoreDispose: (() => void) | undefined;
  timeoutMessageDispose: NodeJS.Timeout | undefined;
  constructor(props: SplashScreenProps) {
    super(props);
    makeObservable(this, {
      timeOutMessage: observable,
      setTimeOutMessage: action,
      // mobileLogoSize: computed,
    });

    this.connectionRestoreDispose = reaction(
      () => props?.connectionStore?.serverConnectionStatus,
      (connected) => {
        if (connected && this.timeOutMessage !== "") {
          this.setTimeOutMessage("Connection Restored");
        }
      },
      { fireImmediately: true }
    );
  }

  setTimeOutMessage = (/** @type {string} */ msg: string) => {
    this.timeOutMessage = msg;
  };

  componentDidMount() {
    if (this.props?.viewStore) {
      this.props.viewStore.checkForAppUpdate();
    }
    this.timeoutMessageDispose = setTimeout(() => {
      if (
        this.props?.connectionStore &&
        !this.props.connectionStore.serverConnectionStatus
      ) {
        this.setTimeOutMessage(CONNECTION_ERROR_MESSAGE);
      } else {
        this.setTimeOutMessage(DEFAULT_ERROR_MESSAGE);
      }
    }, 8000);
  }

  componentWillUnmount() {
    this.timeoutMessageDispose && clearTimeout(this.timeoutMessageDispose);
    this.connectionRestoreDispose && this.connectionRestoreDispose();
  }

  requestHelp = async () => {
    const { logStore, viewStore } = this.props;
    if (!logStore || !viewStore) {
      console.warn("logStore or viewStore is not available");
      return;
    }
    const requestID = utils.uuid();
    const { rootStore, ...actualStore } = viewStore;
    console.log("rootStore", rootStore);
    const storeToJS = toJS(actualStore);

    try {
      const storeToSend = JSON.stringify(storeToJS);
      const created = await logStore.create({
        level: `error`,
        message: `Request ID: ${requestID}`,
        payload: storeToSend,
      });
      runInAction(() => {
        if (created) {
          window.open(
            `mailto:zfrye@intrasyncindustrial.com?subject=Request Help For: ${viewStore.appTitle}&body=Help Request Number: ${requestID}.%0A%0aPlease leave any comments below.`
          );
        }
      });
    } catch (err) {
      console.warn("Error", err);
    }
  };

  get mobileLogoSize() {
    if (!this.props.viewStore) {
      return 200;
    }
    const { viewStore } = this.props;
    return viewStore.cardBodySize.width < 512
      ? viewStore.cardBodySize.width
      : 512;
  }

  render() {
    const { routerStore, viewStore, message = "" } = this.props;
    if (viewStore?.isMobile) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            padding: 10,
            height: viewStore.windowHeight - 30,
          }}
        >
          <div>
            <div style={{ textAlign: "center" }}>
              <Logo background="none" size={this.mobileLogoSize} />
            </div>
            {/*  <h1 style={{ textAlign: 'center', marginTop: 5, marginBottom: 10 }}>
              {viewStore?.appTitle || viewStore?.appName || 'IntraSync'}
            </h1>
            {!this.timeOutMessage && <LinearProgress color="primary" />} */}

            <h3 style={{ textAlign: "center", marginTop: 20, marginBottom: 5 }}>
              {message}
            </h3>
            {routerStore && message === DEFAULT_ERROR_MESSAGE && (
              <div
                style={{
                  width: viewStore.cardBodySize.width - 20,
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  padding: 10,
                }}
              >
                {routerStore.routerHistory?.length > 0 && (
                  <Button color="danger" onClick={() => routerStore.goBack()}>
                    Go Back
                  </Button>
                )}

                {routerStore.routes && "Home" in routerStore.routes && (
                  <>
                    <Spacer />
                    <Button
                      color="success"
                      onClick={() =>
                        routerStore.goTo(
                          routerStore.defaultRoute || "Home",
                          {},
                          { manualFromSplash: true }
                        )
                      }
                    >
                      Go Home
                    </Button>
                  </>
                )}
                {viewStore.cardBodySize.width - 20 > 310 && <Spacer />}
                <Button color="warning" onClick={() => this.requestHelp()}>
                  Request Help
                </Button>
              </div>
            )}
            {routerStore &&
              message === "Connection Restored" &&
              routerStore.routes &&
              "Home" in routerStore.routes && (
                <>
                  <Spacer />
                  <Button
                    color="success"
                    onClick={() =>
                      routerStore.goTo(
                        routerStore.defaultRoute || "Home",
                        {},
                        { manualFromSplash: true }
                      )
                    }
                  >
                    Go Home
                  </Button>
                </>
              )}
            {message === CONNECTION_ERROR_MESSAGE && (
              <div
                style={{
                  width: 500,
                  display: "flex",
                  flexDirection: "row",
                  padding: 10,
                  justifyContent: "center",
                }}
              >
                <Button color="danger" onClick={() => this.requestHelp()}>
                  Request Help
                </Button>
              </div>
            )}
          </div>
        </div>
      );
    }
    return (
      <div style={styles.page}>
        <div style={styles.body}>
          <Logo background="none" size={512} />

          {/* <h1 style={{ textAlign: 'center' }}>
            {viewStore?.appTitle || viewStore?.appName || 'IntraSync'}
          </h1>
          {!this.timeOutMessage && <LinearProgress color="primary" />} */}

          <h3 style={styles.message}>{message}</h3>
          {routerStore && message === DEFAULT_ERROR_MESSAGE && (
            <div
              style={{
                width: 500,
                display: "flex",
                flexDirection: "row",
                padding: 10,
              }}
            >
              {routerStore.routerHistory?.length > 0 && (
                <Button color="danger" onClick={() => routerStore.goBack()}>
                  Go Back
                </Button>
              )}
              <Spacer />

              <Button color="warning" onClick={() => this.requestHelp()}>
                Request Help
              </Button>
              {routerStore.routes && "Home" in routerStore.routes && (
                <>
                  <Spacer />
                  <Button
                    color="success"
                    onClick={() =>
                      routerStore.goTo(
                        routerStore.defaultRoute || "Home",
                        {},
                        { manualFromSplash: true }
                      )
                    }
                  >
                    Go Home
                  </Button>
                </>
              )}
            </div>
          )}
          {routerStore &&
            message === "Connection Restored" &&
            routerStore.routes &&
            "Home" in routerStore.routes && (
              <>
                <Spacer />
                <Button
                  color="success"
                  onClick={() =>
                    routerStore.goTo(
                      routerStore.defaultRoute || "Home",
                      {},
                      { manualFromSplash: true }
                    )
                  }
                >
                  Go Home
                </Button>
              </>
            )}
          {message === CONNECTION_ERROR_MESSAGE && (
            <div
              style={{
                width: 500,
                display: "flex",
                flexDirection: "row",
                padding: 10,
                justifyContent: "center",
              }}
            >
              <Button color="danger" onClick={() => this.requestHelp()}>
                Request Help
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default injectStores(SplashScreen);
